import React from 'react';
import { PartnerDetails } from '../features/b2b';

const B2BPartnerDetailsPage = () => {
  return <PartnerDetails />;
};

export default B2BPartnerDetailsPage;